<div class="modal">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Novi materijal</h3>
    </div>
    <div class="card-body">
      <form [formGroup]="materialForm">
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label class="form-label">Materijal</label>
              <input type="text" class="form-control" name="name" formControlName="name" />
            </div>

            <div class="form-group">
              <label class="form-label">ID Materijala</label>
              <input type="string" class="form-control" name="materialId" formControlName="materialId" />
            </div>
          </div>

          <div class="col-6">
            <div class="form-group">
              <label class="form-label">Vrsta</label>
              <app-dropdown [options]="unitOptions" [parentForm]="materialForm" [parentControl]="'unit'"></app-dropdown>
            </div>

            <div class="form-group">
              <label class="form-label">Cena</label>
              <input type="text" class="form-control" mask="separator.2" thousandSeparator="." decimalMarker="," formControlName="currentUnitPrice" maxlength="13" />
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer text-end">
      <button class="btn btn-secondary btn-question me-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()" [disabled]="materialForm.invalid">Kreiraj</button>
    </div>
  </div>
</div>
